module.exports = __webpack_public_path__ + "images/aegona69416444e4718ceceb2713e6dd49bca.png";